<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#26A6D1" opacity="1.000000" stroke="none" 
	d="
M1.000000,254.000000 
	C1.000000,174.645767 1.000000,95.291542 1.226721,15.809975 
	C6.179165,10.011875 11.065176,4.539184 18.320885,1.968976 
	C18.327507,1.966630 18.111834,1.336746 18.000000,1.000000 
	C19.388889,1.000000 20.777779,1.000000 22.944576,1.200139 
	C25.526365,1.600030 27.330204,1.974187 29.134132,1.974623 
	C143.653778,2.002315 258.173431,2.004937 372.693054,1.958001 
	C374.795502,1.957139 376.897705,1.333211 379.000000,1.000000 
	C380.388885,1.000000 381.777802,1.000000 383.243530,1.254549 
	C383.930695,2.015117 384.463074,2.714783 385.163635,2.996860 
	C391.405334,5.510121 396.494171,9.252601 399.276672,15.640229 
	C399.412201,15.951347 400.405914,15.888628 401.000000,15.999998 
	C401.000000,95.020897 401.000000,174.041794 400.779327,253.172714 
	C396.510315,257.320038 392.461823,261.357178 388.438293,265.419037 
	C388.434235,265.423187 388.804565,265.798187 389.000000,266.000000 
	C263.645782,266.000000 138.291550,266.000000 12.809343,265.780273 
	C9.260763,261.692322 5.853977,257.811523 2.384942,253.987183 
	C2.178686,253.759796 1.473182,253.985260 1.000000,254.000000 
M361.864929,160.634537 
	C353.465851,152.136017 345.066772,143.637497 336.425293,134.893707 
	C349.536987,121.440964 362.265503,108.381348 375.457458,94.846260 
	C374.072174,94.514328 373.481842,94.250168 372.891052,94.249184 
	C356.557983,94.221924 340.224121,94.147530 323.893005,94.325722 
	C322.176971,94.344452 320.048401,95.484894 318.853607,96.786430 
	C315.707031,100.214149 312.969513,104.017410 309.791962,108.020241 
	C305.150024,103.230759 302.338379,99.912041 299.070557,97.128952 
	C297.358948,95.671234 294.850586,94.341843 292.695740,94.331940 
	C256.030182,94.163475 219.363541,94.244835 182.697479,94.147568 
	C179.760803,94.139786 178.187897,95.077797 176.994720,97.736954 
	C174.496948,103.303528 171.677643,108.725822 168.639481,114.923164 
	C165.587311,108.864647 162.784439,103.754623 160.425385,98.447311 
	C159.021393,95.288666 157.238144,94.044052 153.650909,94.116692 
	C141.489349,94.362923 129.319702,94.210564 117.153152,94.210495 
	C115.225098,94.210487 113.297043,94.210495 111.353043,94.210495 
	C111.101746,97.126816 110.915314,99.290276 110.728889,101.453735 
	C108.110397,93.721252 102.226036,93.936584 95.995171,94.139526 
	C87.337769,94.421516 78.660477,94.359093 69.999687,94.135063 
	C66.701309,94.049744 65.013527,95.092308 63.543755,98.130684 
	C51.872910,122.257195 39.988369,146.280304 28.189955,170.345230 
	C27.553019,171.644394 27.100159,173.033813 26.339455,174.937012 
	C40.905663,174.937012 54.877285,174.825073 68.844688,175.018311 
	C72.199768,175.064713 74.136986,174.144104 75.163940,170.898849 
	C75.861458,168.694641 76.973869,166.601517 78.080887,164.556229 
	C78.586914,163.621323 79.489700,162.270767 80.276917,162.225403 
	C84.092934,162.005463 88.145462,161.441132 91.672180,162.487946 
	C93.491241,163.027893 94.406723,166.661102 95.693085,168.917969 
	C96.103340,169.637756 96.516861,170.395020 96.716476,171.188583 
	C97.513550,174.357132 99.570145,175.034973 102.649933,175.003235 
	C117.148262,174.853790 131.649002,174.944473 146.148834,174.923050 
	C147.419846,174.921173 148.690567,174.727783 150.036987,174.617157 
	C150.366638,172.307861 150.650558,170.318878 150.934494,168.329895 
	C151.329651,167.941345 151.724823,167.552795 152.119980,167.164246 
	C152.805222,175.293259 157.818878,175.381561 163.290253,174.984619 
	C166.771896,174.732025 170.316025,174.650269 173.779999,175.003357 
	C179.245834,175.560516 183.662140,174.769058 185.182281,168.549942 
	C185.217758,168.404785 185.748764,168.380753 186.315521,168.228577 
	C186.580399,170.357468 186.839859,172.442841 187.115768,174.660385 
	C188.088272,174.761810 188.893448,174.918900 189.698669,174.919235 
	C223.698349,174.933395 257.698181,174.972046 291.697266,174.833176 
	C293.597778,174.825409 295.803741,173.716660 297.327637,172.463699 
	C301.017303,169.430115 304.387726,166.008286 308.489990,162.180084 
	C311.230957,165.196289 313.822174,167.780563 316.096130,170.618973 
	C318.821045,174.020309 322.098511,175.116287 326.468292,175.043121 
	C340.963715,174.800461 355.466309,174.995224 369.966156,174.996826 
	C371.515686,174.997009 373.065186,174.830673 374.614716,174.741592 
	C374.989410,174.173050 375.364105,173.604492 375.738800,173.035950 
	C371.280334,169.069321 366.821899,165.102692 361.864929,160.634537 
z"/>
<path fill="#20AFDF" opacity="1.000000" stroke="none" 
	d="
M378.531342,1.000000 
	C376.897705,1.333211 374.795502,1.957139 372.693054,1.958001 
	C258.173431,2.004937 143.653778,2.002315 29.134132,1.974623 
	C27.330204,1.974187 25.526365,1.600030 23.361242,1.200139 
	C141.354233,1.000000 259.708466,1.000000 378.531342,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,15.527334 
	C400.405914,15.888628 399.412201,15.951347 399.276672,15.640229 
	C396.494171,9.252601 391.405334,5.510121 385.163635,2.996860 
	C384.463074,2.714783 383.930695,2.015117 383.660156,1.254549 
	C389.586548,1.000000 395.173126,1.000000 401.000000,1.000000 
	C401.000000,5.682189 401.000000,10.368431 401.000000,15.527334 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M17.529545,1.000000 
	C18.111834,1.336746 18.327507,1.966630 18.320885,1.968976 
	C11.065176,4.539184 6.179165,10.011875 1.226721,15.341316 
	C1.000000,10.400794 1.000000,5.801589 1.000000,1.000000 
	C6.351886,1.000000 11.705490,1.000000 17.529545,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M389.479187,266.000000 
	C388.804565,265.798187 388.434235,265.423187 388.438293,265.419037 
	C392.461823,261.357178 396.510315,257.320038 400.779327,253.641373 
	C401.000000,257.921967 401.000000,261.843964 401.000000,266.000000 
	C397.321411,266.000000 393.639893,266.000000 389.479187,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M1.000000,254.479172 
	C1.473182,253.985260 2.178686,253.759796 2.384942,253.987183 
	C5.853977,257.811523 9.260763,261.692322 12.340686,265.780273 
	C8.408029,266.000000 4.816058,266.000000 1.000000,266.000000 
	C1.000000,262.321228 1.000000,258.639801 1.000000,254.479172 
z"/>
<path fill="#FAFDFE" opacity="1.000000" stroke="none" 
	d="
M362.114197,160.885300 
	C366.821899,165.102692 371.280334,169.069321 375.738800,173.035950 
	C375.364105,173.604492 374.989410,174.173050 374.614716,174.741592 
	C373.065186,174.830673 371.515686,174.997009 369.966156,174.996826 
	C355.466309,174.995224 340.963715,174.800461 326.468292,175.043121 
	C322.098511,175.116287 318.821045,174.020309 316.096130,170.618973 
	C313.822174,167.780563 311.230957,165.196289 308.489990,162.180084 
	C304.387726,166.008286 301.017303,169.430115 297.327637,172.463699 
	C295.803741,173.716660 293.597778,174.825409 291.697266,174.833176 
	C257.698181,174.972046 223.698349,174.933395 189.698669,174.919235 
	C188.893448,174.918900 188.088272,174.761810 187.115768,174.660385 
	C186.839859,172.442841 186.580399,170.357468 186.315521,168.228577 
	C185.748764,168.380753 185.217758,168.404785 185.182281,168.549942 
	C183.662140,174.769058 179.245834,175.560516 173.779999,175.003357 
	C170.316025,174.650269 166.771896,174.732025 163.290253,174.984619 
	C157.818878,175.381561 152.805222,175.293259 152.119980,167.164246 
	C151.724823,167.552795 151.329651,167.941345 150.934494,168.329895 
	C150.650558,170.318878 150.366638,172.307861 150.036987,174.617157 
	C148.690567,174.727783 147.419846,174.921173 146.148834,174.923050 
	C131.649002,174.944473 117.148262,174.853790 102.649933,175.003235 
	C99.570145,175.034973 97.513550,174.357132 96.716476,171.188583 
	C96.516861,170.395020 96.103340,169.637756 95.693085,168.917969 
	C94.406723,166.661102 93.491241,163.027893 91.672180,162.487946 
	C88.145462,161.441132 84.092934,162.005463 80.276917,162.225403 
	C79.489700,162.270767 78.586914,163.621323 78.080887,164.556229 
	C76.973869,166.601517 75.861458,168.694641 75.163940,170.898849 
	C74.136986,174.144104 72.199768,175.064713 68.844688,175.018311 
	C54.877285,174.825073 40.905663,174.937012 26.339455,174.937012 
	C27.100159,173.033813 27.553019,171.644394 28.189955,170.345230 
	C39.988369,146.280304 51.872910,122.257195 63.543755,98.130684 
	C65.013527,95.092308 66.701309,94.049744 69.999687,94.135063 
	C78.660477,94.359093 87.337769,94.421516 95.995171,94.139526 
	C102.226036,93.936584 108.110397,93.721252 110.728889,101.453735 
	C110.915314,99.290276 111.101746,97.126816 111.353043,94.210495 
	C113.297043,94.210495 115.225098,94.210487 117.153152,94.210495 
	C129.319702,94.210564 141.489349,94.362923 153.650909,94.116692 
	C157.238144,94.044052 159.021393,95.288666 160.425385,98.447311 
	C162.784439,103.754623 165.587311,108.864647 168.639481,114.923164 
	C171.677643,108.725822 174.496948,103.303528 176.994720,97.736954 
	C178.187897,95.077797 179.760803,94.139786 182.697479,94.147568 
	C219.363541,94.244835 256.030182,94.163475 292.695740,94.331940 
	C294.850586,94.341843 297.358948,95.671234 299.070557,97.128952 
	C302.338379,99.912041 305.150024,103.230759 309.791962,108.020241 
	C312.969513,104.017410 315.707031,100.214149 318.853607,96.786430 
	C320.048401,95.484894 322.176971,94.344452 323.893005,94.325722 
	C340.224121,94.147530 356.557983,94.221924 372.891052,94.249184 
	C373.481842,94.250168 374.072174,94.514328 375.457458,94.846260 
	C362.265503,108.381348 349.536987,121.440964 336.425293,134.893707 
	C345.066772,143.637497 353.465851,152.136017 362.114197,160.885300 
M123.988373,107.734848 
	C123.988373,124.451218 123.988373,141.167587 123.988373,157.883957 
	C122.374069,156.814133 121.635963,155.596634 121.021416,154.319656 
	C115.898354,143.674332 110.824478,133.005264 105.679832,122.370422 
	C103.074173,116.984100 101.653122,109.527885 97.326912,106.882103 
	C92.793877,104.109848 85.410629,106.154213 79.295509,105.752533 
	C75.788696,105.522186 74.007729,106.783203 72.513603,109.970924 
	C64.817116,126.391350 56.857933,142.688568 49.013275,159.039749 
	C48.408802,160.299713 47.980656,161.644272 47.233845,163.555176 
	C49.675014,163.555176 51.524799,163.279251 53.263195,163.602432 
	C61.223866,165.082443 66.250793,162.164627 68.126534,154.151703 
	C68.841095,151.099152 71.020584,150.620621 73.812881,150.685562 
	C80.140129,150.832703 86.537834,151.296768 92.786743,150.581833 
	C99.912331,149.766602 104.019020,152.109070 105.983536,159.019241 
	C106.475281,160.748932 108.480759,163.270355 109.873245,163.325119 
	C119.484154,163.703171 129.116974,163.524124 139.414932,163.524124 
	C139.414932,148.838272 139.414932,134.720276 139.414932,120.602264 
	C146.173660,132.057373 152.369629,143.458710 157.508820,155.317993 
	C160.303970,161.768143 163.756897,164.590576 170.898270,163.740799 
	C174.346436,163.330475 176.188782,162.371384 177.653061,159.298691 
	C183.307755,147.432693 189.185501,135.672806 195.008942,123.887634 
	C195.617355,122.656372 196.416641,121.519440 197.127365,120.338753 
	C197.401718,120.429176 197.676056,120.519608 197.950409,120.610031 
	C197.950409,134.711472 197.950409,148.812897 197.950409,163.231064 
	C203.086761,163.231064 207.831955,163.231064 212.771942,163.231064 
	C212.771942,144.072495 212.771942,125.184456 212.771942,105.836067 
	C204.995789,105.836067 197.529510,105.676468 190.083008,105.988647 
	C188.798874,106.042496 187.151291,107.871346 186.436539,109.270927 
	C183.183655,115.640419 180.205383,122.150108 177.125931,128.608231 
	C174.681778,133.734055 172.234116,138.858200 169.375427,144.847504 
	C162.979507,132.482117 157.130524,121.108429 151.193863,109.780685 
	C150.461884,108.383995 149.266861,106.143188 148.278793,106.139099 
	C140.232864,106.105797 132.185120,106.511971 123.988373,107.734848 
M246.500534,105.813736 
	C240.219116,105.813736 233.937698,105.813736 227.399841,105.813736 
	C227.399841,125.257553 227.399841,144.122879 227.399841,163.155609 
	C228.484955,163.312637 229.288910,163.529617 230.093140,163.530624 
	C248.575516,163.553619 267.058990,163.644836 285.538696,163.424667 
	C287.534943,163.400879 289.847504,161.917938 291.432953,160.474426 
	C297.053436,155.357132 302.422241,149.963333 308.045715,144.520081 
	C313.737122,150.210571 319.000763,155.518005 324.327698,160.761154 
	C325.369019,161.786102 326.623260,163.276123 327.834778,163.331177 
	C333.730377,163.599106 339.644806,163.452286 345.552582,163.452286 
	C345.717957,163.056839 345.883301,162.661392 346.048676,162.265945 
	C336.820923,153.221252 327.593170,144.176575 317.170898,133.961075 
	C326.959076,124.563278 336.324493,115.571373 346.487457,105.813766 
	C341.474670,105.813766 337.653656,106.080452 333.886597,105.743820 
	C329.533722,105.354820 326.375519,106.804337 323.402435,109.988701 
	C318.684052,115.042336 313.527496,119.686905 307.964569,125.078003 
	C303.186310,120.054337 298.642090,115.651604 294.553619,110.859978 
	C291.263916,107.004478 287.611938,105.508751 282.462646,105.687027 
	C270.821045,106.090080 259.155853,105.813736 246.500534,105.813736 
z"/>
<path fill="#2AA8D2" opacity="1.000000" stroke="none" 
	d="
M124.063141,107.259621 
	C132.185120,106.511971 140.232864,106.105797 148.278793,106.139099 
	C149.266861,106.143188 150.461884,108.383995 151.193863,109.780685 
	C157.130524,121.108429 162.979507,132.482117 169.375427,144.847504 
	C172.234116,138.858200 174.681778,133.734055 177.125931,128.608231 
	C180.205383,122.150108 183.183655,115.640419 186.436539,109.270927 
	C187.151291,107.871346 188.798874,106.042496 190.083008,105.988647 
	C197.529510,105.676468 204.995789,105.836067 212.771942,105.836067 
	C212.771942,125.184456 212.771942,144.072495 212.771942,163.231064 
	C207.831955,163.231064 203.086761,163.231064 197.950409,163.231064 
	C197.950409,148.812897 197.950409,134.711472 197.950409,120.610031 
	C197.676056,120.519608 197.401718,120.429176 197.127365,120.338753 
	C196.416641,121.519440 195.617355,122.656372 195.008942,123.887634 
	C189.185501,135.672806 183.307755,147.432693 177.653061,159.298691 
	C176.188782,162.371384 174.346436,163.330475 170.898270,163.740799 
	C163.756897,164.590576 160.303970,161.768143 157.508820,155.317993 
	C152.369629,143.458710 146.173660,132.057373 139.414932,120.602264 
	C139.414932,134.720276 139.414932,148.838272 139.414932,163.524124 
	C129.116974,163.524124 119.484154,163.703171 109.873245,163.325119 
	C108.480759,163.270355 106.475281,160.748932 105.983536,159.019241 
	C104.019020,152.109070 99.912331,149.766602 92.786743,150.581833 
	C86.537834,151.296768 80.140129,150.832703 73.812881,150.685562 
	C71.020584,150.620621 68.841095,151.099152 68.126534,154.151703 
	C66.250793,162.164627 61.223866,165.082443 53.263195,163.602432 
	C51.524799,163.279251 49.675014,163.555176 47.233845,163.555176 
	C47.980656,161.644272 48.408802,160.299713 49.013275,159.039749 
	C56.857933,142.688568 64.817116,126.391350 72.513603,109.970924 
	C74.007729,106.783203 75.788696,105.522186 79.295509,105.752533 
	C85.410629,106.154213 92.793877,104.109848 97.326912,106.882103 
	C101.653122,109.527885 103.074173,116.984100 105.679832,122.370422 
	C110.824478,133.005264 115.898354,143.674332 121.021416,154.319656 
	C121.635963,155.596634 122.374069,156.814133 123.988373,157.883957 
	C123.988373,141.167587 123.988373,124.451218 124.063141,107.259621 
M84.564491,138.767731 
	C88.279701,138.767731 91.994911,138.767731 96.512497,138.767731 
	C92.806770,130.694580 89.567696,123.638054 85.837860,115.512383 
	C82.017693,123.882126 78.823204,130.881058 75.223557,138.767670 
	C78.752449,138.767670 81.185417,138.767670 84.564491,138.767731 
z"/>
<path fill="#2CA8D2" opacity="1.000000" stroke="none" 
	d="
M247.000397,105.813728 
	C259.155853,105.813736 270.821045,106.090080 282.462646,105.687027 
	C287.611938,105.508751 291.263916,107.004478 294.553619,110.859978 
	C298.642090,115.651604 303.186310,120.054337 307.964569,125.078003 
	C313.527496,119.686905 318.684052,115.042336 323.402435,109.988701 
	C326.375519,106.804337 329.533722,105.354820 333.886597,105.743820 
	C337.653656,106.080452 341.474670,105.813766 346.487457,105.813766 
	C336.324493,115.571373 326.959076,124.563278 317.170898,133.961075 
	C327.593170,144.176575 336.820923,153.221252 346.048676,162.265945 
	C345.883301,162.661392 345.717957,163.056839 345.552582,163.452286 
	C339.644806,163.452286 333.730377,163.599106 327.834778,163.331177 
	C326.623260,163.276123 325.369019,161.786102 324.327698,160.761154 
	C319.000763,155.518005 313.737122,150.210571 308.045715,144.520081 
	C302.422241,149.963333 297.053436,155.357132 291.432953,160.474426 
	C289.847504,161.917938 287.534943,163.400879 285.538696,163.424667 
	C267.058990,163.644836 248.575516,163.553619 230.093140,163.530624 
	C229.288910,163.529617 228.484955,163.312637 227.399841,163.155609 
	C227.399841,144.122879 227.399841,125.257553 227.399841,105.813736 
	C233.937698,105.813736 240.219116,105.813736 247.000397,105.813728 
M291.030518,127.490875 
	C285.305969,119.534607 277.816498,116.533279 267.893982,117.621429 
	C259.711792,118.518715 251.352905,117.804642 242.844727,117.804642 
	C242.844727,121.521851 242.844727,124.585587 242.844727,128.304916 
	C254.052078,128.304916 264.956635,128.304916 275.947693,128.304916 
	C275.947693,132.519806 275.947693,136.072586 275.947693,140.242691 
	C264.667084,140.242691 253.780243,140.242691 242.519180,140.242691 
	C242.519180,142.519867 242.690491,144.190979 242.486145,145.814819 
	C241.933762,150.204391 243.305298,152.014893 248.153076,151.814011 
	C257.634460,151.421082 267.144470,151.761917 276.640564,151.639633 
	C278.359283,151.617508 280.627502,151.384277 281.687134,150.308197 
	C286.931488,144.982529 291.855286,139.341202 297.585266,133.050049 
	C296.131042,131.834702 293.834198,129.915207 291.030518,127.490875 
z"/>
<path fill="#F4FAFD" opacity="1.000000" stroke="none" 
	d="
M84.091446,138.767700 
	C81.185417,138.767670 78.752449,138.767670 75.223557,138.767670 
	C78.823204,130.881058 82.017693,123.882126 85.837860,115.512383 
	C89.567696,123.638054 92.806770,130.694580 96.512497,138.767731 
	C91.994911,138.767731 88.279701,138.767731 84.091446,138.767700 
z"/>
<path fill="#FAFDFE" opacity="1.000000" stroke="none" 
	d="
M291.283936,127.743286 
	C293.834198,129.915207 296.131042,131.834702 297.585266,133.050049 
	C291.855286,139.341202 286.931488,144.982529 281.687134,150.308197 
	C280.627502,151.384277 278.359283,151.617508 276.640564,151.639633 
	C267.144470,151.761917 257.634460,151.421082 248.153076,151.814011 
	C243.305298,152.014893 241.933762,150.204391 242.486145,145.814819 
	C242.690491,144.190979 242.519180,142.519867 242.519180,140.242691 
	C253.780243,140.242691 264.667084,140.242691 275.947693,140.242691 
	C275.947693,136.072586 275.947693,132.519806 275.947693,128.304916 
	C264.956635,128.304916 254.052078,128.304916 242.844727,128.304916 
	C242.844727,124.585587 242.844727,121.521851 242.844727,117.804642 
	C251.352905,117.804642 259.711792,118.518715 267.893982,117.621429 
	C277.816498,116.533279 285.305969,119.534607 291.283936,127.743286 
z"/>
</svg>